import { Text, TextProps } from '@chakra-ui/react';
import { HelivanColor } from './HelivanColor';

interface HelivanTextProps extends TextProps {
  variant?:
    | 'smallBody'
    | 'smallBody+'
    | 'tinyBody'
    | 'tinyBody+'
    | 'largeBody'
    | 'largeBody+'
    | 'xlargeBody'
    | 'xlargeBody+'
    | 'subheader'
    | 'largeSubheader'
    | 'pageHeader'
    | 'sectionHeader'
    | 'headerLite';
  colorOverride?: string;
  lineHeightOverride?: string;
  fontWeightOverride?: number;
}

export const HelivanText = ({ ...props }: HelivanTextProps) => {
  let fontSize = '14px';
  let fontWeight = 400;
  let textColor = HelivanColor.text.blueMid;
  let lineHeight = undefined;

  switch (props.variant) {
    case 'largeBody': {
      fontSize = '14px';
      fontWeight = 400;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'largeBody+': {
      fontSize = '14px';
      fontWeight = 600;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'xlargeBody': {
      fontSize = '20px';
      fontWeight = 400;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'xlargeBody+': {
      fontSize = '20px';
      fontWeight = 600;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'smallBody': {
      fontSize = '12px';
      fontWeight = 400;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'smallBody+': {
      fontSize = '12px';
      fontWeight = 600;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'pageHeader': {
      fontSize = '32px';
      fontWeight = 600;
      textColor = HelivanColor.text.black;
      lineHeight = '115%';
      break;
    }
    case 'sectionHeader': {
      fontSize = '20px';
      fontWeight = 600;
      textColor = HelivanColor.text.black;
      break;
    }
    case 'largeSubheader': {
      fontSize = '16px';
      fontWeight = 600;
      textColor = HelivanColor.text.black;
      break;
    }
    case 'subheader': {
      fontSize = '12px';
      fontWeight = 600;
      textColor = HelivanColor.text.black;
      break;
    }
    case 'tinyBody': {
      fontSize = '10px';
      fontWeight = 400;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'tinyBody+': {
      fontSize = '10px';
      fontWeight = 600;
      textColor = HelivanColor.text.blueMid;
      break;
    }
    case 'headerLite': {
      fontSize = '16px';
      fontWeight = 500;
      textColor = HelivanColor.text.black;
      break;
    }
  }

  if (props.colorOverride) {
    textColor = props.colorOverride;
  }

  if (props.lineHeightOverride) {
    lineHeight = props.lineHeightOverride;
  }

  if (props.fontWeightOverride) {
    fontWeight = props.fontWeightOverride;
  }

  const {
    colorOverride,
    fontWeightOverride,
    lineHeightOverride,
    ...textProps
  } = props;

  return (
    <Text
      {...textProps}
      fontSize={fontSize}
      fontWeight={fontWeight}
      textColor={textColor}
      lineHeight={lineHeight}
    >
      {props.children}
    </Text>
  );
};
